import { connect } from 'react-redux';
import i18next from 'i18next';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

import { showConfirmationMessage } from '@actions/messageconfirmation';

import { DATE_DISPLAY_FORMATS } from '@commons/DatePickers/constants';
import { TRANSFER_STATUS_LABELS } from '@stocks/StocksInventories/Transfers/utils/constants';
import utilsXLS from '@commons/utils/makeXLS';

import ExportModalContent from '@lib/inpulse/ExportModal';

export const ExportListModal = (props) => {
  const {
    params: {
      title,
      mainSheetData,
      clientStoreNameTranslation,
      hasTransferDeliveryTime,
      sheetName,
      currency,
    },
    closeModal,
    showErrorMessage,
  } = props;

  const [progress, setProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [titleModal, setTitleModal] = useState(title || '');

  const MAIN_SHEET_COLUMNS_SETTINGS = [
    {
      name: i18next.t('GENERAL.REFERENCE'),
      propertyKey: 'reference',
    },
    {
      name: i18next.t('STOCKS.TRANSFERS.RECIPIENT_STORE', {
        storeName: clientStoreNameTranslation,
      }),
      propertyKey: 'recipient',
    },
    {
      name: i18next.t('STOCKS.TRANSFERS.SENDER_STORE', {
        storeName: clientStoreNameTranslation,
      }),
      propertyKey: 'sender',
    },
    {
      name: i18next.t('STOCKS.TRANSFERS.SENDING_DATE'),
      propertyKey: 'sentAt',
      transform: (value) => moment(value).format(DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR),
    },
  ];

  if (hasTransferDeliveryTime) {
    MAIN_SHEET_COLUMNS_SETTINGS.push({
      name: i18next.t('STOCKS.TRANSFERS.DELIVERY_TIME'),
      propertyKey: 'deliveryTime',
    });
  }

  MAIN_SHEET_COLUMNS_SETTINGS.push(
    {
      name: i18next.t('STOCKS.TRANSFERS.SENDING_STATUS'),
      propertyKey: 'status',
      transform: (status) => i18next.t(TRANSFER_STATUS_LABELS[status]),
    },
    {
      name: i18next.t('STOCKS.TRANSFERS.TOTAL_TRANSFER_NOTE'),
      propertyKey: 'totalTransferNote',
    },
    {
      name: i18next.t('STOCKS.TRANSFERS.TOTAL_DELIVERY_NOTE'),
      propertyKey: 'totalDeliveryNote',
    },
    {
      name: i18next.t('STOCKS.TRANSFERS.TOTAL_RECEIVED'),
      propertyKey: 'totalReceived',
      type: 'currency',
    },
  );

  useEffect(() => {
    try {
      const mainSheet = utilsXLS.generateDefaultSheet(
        sheetName,
        MAIN_SHEET_COLUMNS_SETTINGS,
        mainSheetData,
        currency,
      );

      utilsXLS.makeXLS(sheetName, [mainSheet]);
      setTitleModal(i18next.t('GENERAL.EXPORT_SUCCESS'));
      setIsLoading(false);
    } catch {
      showErrorMessage(i18next.t('GENERAL.EXPORT_FAILURE'));
      exitModal();
    }
  }, []);

  useEffect(() => {
    if (isLoading && progress < 100) {
      setProgress(100);
    }
  }, [progress]);

  const exitModal = () => {
    setIsLoading(false);
    closeModal();
  };

  return (
    <ExportModalContent
      {...props}
      closeModal={closeModal}
      exitModal={exitModal}
      isLoading={isLoading}
      progress={progress}
      setLoading={setIsLoading}
      titleModal={titleModal}
    />
  );
};

const mapDispatchToProps = (dispatch) => ({
  showErrorMessage: (message) => {
    dispatch(showConfirmationMessage(message, 'error'));
  },
});

export default connect(null, mapDispatchToProps)(ExportListModal);
